import { createFileRoute } from '@tanstack/react-router'
import { PaymentConfirmation } from '@/features/accommodation/confirmation/components/PaymentConfirmation'
import { SITE_NAME, noindexMeta } from '@/lib/seo/siteMeta'

export const Route = createFileRoute('/_layout/ubytovani/$slug/$unitSlug/potvrzeni')({
  component: ConfirmationPage,
  head: () => ({
    meta: [{ title: `Potvrzení rezervace | ${SITE_NAME}` }, ...noindexMeta()],
  }),
})

function ConfirmationPage() {
  return (
    <>
      <PaymentConfirmation
        reservationData={{
          dates: {
            from: new Date(),
            to: new Date(),
          },
          numberOfPeople: 2,
        }}
        bookingReference={''}
      />
    </>
  )
}
